"use client";

import { useTranslation } from "react-i18next";
import { Icon } from "@iconify-icon/react";
import { motion } from "motion/react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface LeaveCallDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function LeaveCallDialog({ isOpen, onClose, onConfirm }: LeaveCallDialogProps) {
  const { t } = useTranslation(["common", "classroom"]);

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="bg-background border-border max-w-[400px] rounded-xl">
        <AlertDialogHeader>
          <motion.div
            animate={{ scale: 1, opacity: 1 }}
            className="mb-2 flex justify-center"
            initial={{ scale: 0.9, opacity: 0 }}
          >
            <div className="bg-destructive/10 text-destructive flex h-12 w-12 items-center justify-center rounded-full">
              <Icon height="24" icon="lucide:phone-off" width="24" />
            </div>
          </motion.div>
          <AlertDialogTitle className="text-accent-foreground text-center">
            {t("classroom:leaveCallConfirmTitle")}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-muted-foreground text-center">
            {t("classroom:leaveCallConfirmDescription")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col space-y-2 sm:space-y-0">
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90 w-full"
            onClick={onConfirm}
          >
            {t("classroom:leaveCall")}
          </AlertDialogAction>
          <AlertDialogCancel className="border-border text-accent-foreground mt-0 w-full">
            {t("common:cancel")}
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
